import { Injectable } from '@angular/core';
import OpenReplay, { Options } from '@openreplay/tracker';
import { environment } from '../../environments/environment';

const ALLOWED_ENVS = ['prod'];

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  isInitialized = false;
  tracker!: OpenReplay;
  public sessionId?: string | null | undefined;

  public async init(options?: Options): Promise<void> {
    if (!ALLOWED_ENVS.includes(environment.environment)) {
      return;
    }
    if (!this.isInitialized) {
      const trackerOptions: Options = {
        projectKey: environment.trackingProjectKey,
        ingestPoint: environment.trackingIngestUrl,
        // __DISABLE_SECURE_MODE: true,
        defaultInputMode: 0,
        obscureTextEmails: false,
        obscureInputEmails: false,
        consoleMethods: ['error'],
        captureResourceTimings: false,
        capturePageLoadTimings: false,
        capturePageRenderTimings: false,
        capturePerformance: false,
        network: {
          sessionTokenHeader: false,
          failuresOnly: true,
          ignoreHeaders: false,
          captureInIframes: true,
          capturePayload: true
        },
        ...options
      };
      this.tracker = new OpenReplay(trackerOptions);
      this.isInitialized = true;
    }
    try {
      await this.tracker.start();
      this.sessionId = this.tracker.getSessionID();
      console.log(`[${environment.environment}] Tracking is initalized with session ${this.sessionId}`);
    } catch (error) {
      console.log(`[${environment.environment}] Tracking is not initalized`);
      console.error(error);
    }
  }

  identify(userId = '', userEmail = '', companyCode = '', companyId = ''): void {
    if (!this.isInitialized) {
      return;
    }
    this.tracker.setUserID(userEmail || userId);
    this.tracker.setMetadata('user_id', userId);
    this.tracker.setMetadata('company_code', companyCode);
    this.tracker.setMetadata('company_id', companyId);
    this.tracker.setMetadata('env', environment.environment);
    this.tracker.setMetadata('version', environment.version);
    console.log('[identify] Tracking user is identified with ID', this.tracker.getSessionID());
  }

  trackEvent(name: string, payload?: unknown, issue?: boolean): void {
    if (!this.isInitialized) {
      return;
    }
    this.tracker.event(name, payload, issue);
  }
}
